export function logEvent(event_name: string, extra: any=null) {
    const data = extra ?? {};
    data['event'] = event_name;
    data['is_logged_in'] = !!localStorage.getItem('access_token');
    if (window.hasOwnProperty('dataLayer')) {
        (<any>window).dataLayer.push(data);
    }
}